import Inicial from '@/components/xiiencontro/Index'

import {requireAdminAuth} from './base.js'

export default [
  {
    path: '/admin/xiiencontro/',
    name: 'xiiencontro-index',
    component: Inicial,
    beforeEnter: requireAdminAuth
    
  },
   
 
]
